export const searchColumn = [
  {
    type: 'selectInput',
    prop: 'search_value',
    label: '',
    selectKey: 'search_key',
    placeholder: 'Search..',
    width: '120',
    inputValue: '',
    selectValue: '',
    options: [
      { label: 'Tracking#', value: 'tracking_no' },
      { label: 'Sender', value: 'sender' },
      { label: 'Recipient', value: 'recipient' },
      { label: "Sender's phone", value: 'sender_phone' },
      { label: "Receipient's phone", value: 'recipient_phone' },
      { label: "Sender's email", value: 'sender_email' },
      { label: "Receipient's email", value: 'recipient_email' },
    ]
  },
  {
    type: 'select',
    prop: 'from_city',
    label: 'From (City)',
    placeholder: 'All',
    option_label:'zone_name',
    option_value:"id",
    options: []
  },
  {
    type: 'select',
    prop: 'to_city',
    label: 'To (City)',
    option_label:'zone_name',
    option_value:"id",
    placeholder: 'All',
    options: []
  },
  {
    type: 'select',
    prop: 'parcel_type',
    label: 'Parcel type',
    option_label:'type_name_en',
    option_value:"id",
    placeholder: 'All',
    options: []
  },
  {
    type: 'date',
    prop: 'from_date',
    label: 'From',
    placeholder: 'Select a date',
  },
  {
    type: 'date',
    prop: 'to_date',
    label: 'To',
    placeholder: 'Select a date',
  }
]
